


import { useState, useEffect } from 'react';
import { supabase } from '../supabase';



import { getIcon } from '../utils/iconMap';

const useSocialPlatforms = () => {
  const [platforms, setPlatforms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const { data, error } = await supabase
          .from('integrations')
          .select('*')
          .eq('category', 'social')
          .neq('status', 'hidden')
          .order('name', { ascending: true });

        if (error) throw error;

        const mappedPlatforms = data.map(platform => {
          // Backward compatibility mappings for legacy UI state that expected generic names
          // We no longer aggressively map everything to generic IDs to avoid duplicates (like linkedin and linkedin_page merging)
          // For legacy support where posts might strictly look for 'facebook' or 'linkedin'
          // We will preserve id as the real key for new stuff but keep a generic legacy_id if needed.
          // However, to fix duplicate selections, id must be unique. We'll use platform.key directly
          // and let the UI handle fallback matches if it needs to.

          return {
            id: platform.key, // Uniquely identifies the platform integration (e.g. linkedin_page)
            original_id: platform.key, // Keeps track of actual integration key for connection checks
            name: platform.name,
            icon: getIcon(platform.icon_key), // Fallback icon
            color: platform.color || 'bg-charcoal-500', // Ensure color represents bg class
            status: platform.status
          };
        });

        setPlatforms(mappedPlatforms);
      } catch (error) {
        console.error('Error fetching social platforms:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlatforms();
  }, []);

  return { platforms, isLoading };
};

export default useSocialPlatforms;
